import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { Tab, Tabs } from "react-bootstrap";
import Workdrive from "../../components/Workdrive/workdrive";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faUpload } from "@fortawesome/free-solid-svg-icons";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import attachIcon from "../../assets/images/task-attachment-icon.png";
import { Badge, Button, Card, Tooltip } from "antd";
import './AttachmentModal.css'
import icon from '../../assets/images/zoho-Workdrive-tr.png';
import { CloudUploadOutlined, DeleteOutlined, HomeFilled, PlusOutlined } from "@ant-design/icons";
import { WorkdriveFolderPicker } from "../../components/FolderPicker/WorkdriveFolderPicker";
import AwsServerService from "../../common/util/AwsServerService";
import { RefreshData, SelectedFiles, setRefershModule } from "../../Context/ReduxContext";
import { useSelector, useDispatch } from 'react-redux';
import { CustomeCollapse } from "./AddTaskTabs/CustomeCollapse";
import Meta from "antd/es/card/Meta";
import AppContext from "../../Context/AppContext";
import { refershModule, Socket } from "../../Context/AppActions";
import { useContext } from "react";
import { convertToBase64 } from "./TaskUtil";
import GlobalTable from "../../common/DealTableChart/GlobalTable";
import { CustomeTableComponent } from "./ViewPipelinesTabs/DependencyTable/CustomeTableComponent";
import TaskService from "../../common/util/TaskService";
import { setNotificationFlag } from "../../Context/ReduxContext";

const AttachmentModal = (props) => {
  const [key, setKey] = useState("desktop");
  const [workdriveUploadModal, setWorkdriveUploadModal] = useState(false);
  const [relativePathId,setRelativePathId] = useState("");
  const [AllAttachments,setAllAttachments] = useState([]);
  const AppData = useContext(AppContext);
  const [uploadStack,setUploadStack] = useState([]);
  const { dispatch ,state} = AppData || {};
  const dispatchRedux = useDispatch();
  const [uploading,setUploading] = useState(false);
  const [activeView, setActiveView] = useState('List')
  let allAppUsers = state.AllAppUsers || [];
  const getNotification = useSelector((state) => state.AppReduxContext.getNotificationFlag);
  // const { isTaskModalClosed } = state;
  const RefershModule = useSelector((state) => state.AppReduxContext.refershModule)
  const fetchAttchmets =()=>{
    AwsServerService.CrudServiceHandler({method:"GETWHERE",route:"ATTACHMENTS",data:{TaskId:props.TaskId,TaskType:props.TaskType}}).then(res=>{
      setAllAttachments(res.data);
    }).catch(e=>{
      console.log(e);
    })
  }
  useEffect(e=>{
    
    if((RefershModule && RefershModule.module == 'TASK-ATTACHMENTS')){
      fetchAttchmets();
      dispatchRedux(setRefershModule({ module: "",trigger:"", data: "" }))
    }
  },[RefershModule])

  useEffect(e=>{
    if(props.isTaskModalClosed){
      setAllAttachments([])
    }
  },[props.isTaskModalClosed])
  useEffect(e=>{
    
    if(props.TaskId){
      fetchAttchmets();
    }
  },[props.TaskId])
  const getIcon = (ext, one) => {
    ext = ext.toLowerCase();
    if (ext == "txt") {
      return <FontAwesomeIcon size="5x" className="file-icon" icon={faFile} />;
    } else if (
      ext == "png" ||
      ext == "jpg" ||
      ext == "svg" ||
      ext == "JPEG" ||
      ext == "jpeg"
    ) {
      return <embed src={one.base64} height="100" width="100" />;
    } else if (ext == "pdf") {
      return <embed src={one.base64} height="100" width="100" />;
    } else {
      return <img className="file-icon" src={attachIcon} />;
    }
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // upload functions 
  
  const handleFileAttachments = async (fileList) => {
    
    let tempFileCollection = [...uploadStack];
    let length = fileList.length;
    let index = 0;
    while (index < length) {
      let fileName = fileList[index].name;
      let type = fileList[index].type;
      let base64 = await convertToBase64(fileList[index]);
      tempFileCollection.push({
        fileName: fileName,
        file: fileList[index],
        base64:base64,
        type: type
      });
      index = index + 1;
    }
    setUploadStack(tempFileCollection);
    
  };
  const handleUploadFiles = () => {
    let link = document.createElement('input');
    link.setAttribute('type', 'file');
    link.setAttribute('name', 'uploadFiles');
    link.setAttribute('multiple', "multiple");
    document.body.appendChild(link);
    link.click();
    link.onchange = function (e) {
      handleFileAttachments(e.currentTarget.files);
    }
    document.body.removeChild(link);
  }
  const handleUploadFileWorkDrive = (fileObj) => {
    return new Promise((resolve, reject) => {
      if (props.relativePathId) {
        AwsServerService.UploadFileWorkDrive(fileObj, props.relativePathId, localStorage.getItem('token'))
          .then(async function (response) {
            
            let  res = response?.data?.data[0]
            let obj = {
              name: res?.attributes.FileName,
              permalink: res?.attributes.Permalink,
              thumbnailUrl: res?.attributes.thumbnail_url || "",
              TaskId: props.TaskId,
              TaskType: props.TaskType,
              id: res?.attributes?.resource_id,
            }
            AwsServerService.CrudServiceHandler({method:"POST",data:obj,route:"ATTACHMENTS"}).then(e=>{
              resolve(obj);
            })
          })
          .catch(function (error) {
            reject(error);
          });
      }
    })
  }
  const uploadFiles = (arr) => {
    
    Promise.all(arr?.map(k=>handleUploadFileWorkDrive(k.file))).then((arr) => {
      
      dispatch(Socket({module:"TASK-ATTACHMENTS",trigger:"Refresh_Module",data:"TASK-ATTACHMENTS"}))
      let names = arr.map(k=>k.name);
      // arr.forEach((one) => {
      //   one.Status = "Success"
      // })
      let filterTemp = uploadStack.filter(e => !names.includes(e.fileName))
      setUploadStack(filterTemp);
      console.log(arr);
    }).catch((err) => {
        console.log(err);
    })
  }

  //
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    props.handleFileAttachments(droppedFiles);
  };
  const addUploadedAttachmentToDB =async (files) =>{
    
    return new Promise((resolve,rejetct)=>{
      Promise.all(files.map(file=>{
        return AwsServerService.CrudServiceHandler({method:"POST",data:file,route:"ATTACHMENTS"})
      })).then(res=>{
        resolve(res);
      }).catch(e=>{
        rejetct("Error while adding files to DB");
      })
    })
  }
  const handleUploadFromWorkdrive = async (data) => {
    const documentNames = Object.values(data).map(item => item?.name).join(", ");
    let arr = [];
    for (let fileKey of Object.keys(data)) {
      arr.push({
        attributes: {
          resource_id: fileKey
        },
        type: "files"
      });
    }
    try {
      setUploading(true);
      await AwsServerService.ensureFolderPathExists(props?.data?.zohoworkdriveforcrm__Workdrive_Folder_ID, ["Documents", "Task"], localStorage.getItem('token')).then( async ParentFolderId => {
        let zuidArr = [];
        let text = '';
          text = (
            <>
              added attachament{' '}
              <span style={{ fontWeight: 'bold' , whiteSpace:"nowrap"}}>
                {documentNames}
              </span>
              <span>{' '} in task</span>
            </>
          );
          zuidArr = [...zuidArr, props?.taskData?.Assignee, props?.taskData?.Supervisor]

        const renderToHtml = (element) =>
        require('react-dom/server').renderToString(element);
        await TaskService.SendAssignedNotification(zuidArr,allAppUsers,props?.taskData,props?.data,"Attachment", renderToHtml(text)).then(e=>{
          dispatchRedux(setNotificationFlag(!getNotification));
        }).catch(e=>{})
        if (ParentFolderId) {
          AwsServerService.CopyFileWorkDrive(arr, ParentFolderId, localStorage.getItem("token")).then(res => {
            
            let filesUploaded = res?.data?.data;
            let arr = []
            for(let file of filesUploaded){
              arr.push({
                name:file.attributes.name,
                permalink:file.attributes.permalink,
                thumbnailUrl:file.attributes.thumbnail_url,
                TaskType:props.TaskType,
                TaskId:props.TaskId,
                id:file.id,
              })
            }
            addUploadedAttachmentToDB(arr).then(res=>{
              ;
              dispatch(Socket({module:"TASK-ATTACHMENTS",trigger:"Refresh_Module",data:"TASK-ATTACHMENTS"}))
            }).catch(e=>{
              console.log(e);
              
            })
            setWorkdriveUploadModal(false);
          }).catch(err => {
            throw new Error('Upload failed');
          }).finally(e=>{
            setUploading(false);
          })
        }

      }).catch(e=>{
        throw new Error('Error while locating path');
      }).finally(e=>{
        setUploading(false);
      })

    } catch (error) {
      console.log(error);
      setUploading(false)
    }

  }
  const removeAttachment=(att)=>{
    
    if(att){
      AwsServerService.CrudServiceHandler({method:"DELETE",data:att.ROWID,route:"ATTACHMENTS"}).then(res=>{
        
        dispatch(Socket({module:"TASK-ATTACHMENTS",trigger:"Refresh_Module",data:"TASK-ATTACHMENTS"}))
        AwsServerService.handleRenameFolder({id:att.id,renameValue:"Archive_"+att.name},localStorage.getItem('token')).then(res=>{
        }).catch(e=>{
        })
      }).catch(e=>{
        console.log(e);
      })
    }
  }
  const handleAttachementRemove = (one) => {
    let tempFileCollection = [...uploadStack];
    tempFileCollection = tempFileCollection.filter((file) => file.fileName !== one.fileName);
    setUploadStack(tempFileCollection);
  }

  const DependanciesHeaders = [
    {
      label: "Attachment Name",
      field: "name",
      render: (data, field) => {
        return (
          // <Row className="D-Task-Name" style={{
          //   display: "flex",
          //   height: "41px",
          //   alignItems: "center",
          //   "justify-content": "center",
          //   "width":"100%",
          //   cursor: "pointer"
          // }} sm={12}
          // onClick={e=>{
          //   openTaskFromDependencies(data);
          // }}
          // >
          //   <Col
          //     style={{
          //       display: "flex",
          //       flexDirection: "row",
          //       "align-items": "center",
          //       "justify-content": "center",
          //       "width":"100%",
          //       gap: "10px",
          //     }}>
          //      {data.IsResolved==1 && <FontAwesomeIcon style={{
          //       position:"absolute",
          //       left:"0px",
          //     }} className="ml-2" color={data.IsResolved==1?"green":"#ffce00"} icon={faCheckCircle} />} 
          //     <Tooltip color="rgb(54 54 54)" placement="top" title={data[field]}><span className='Elipsis-Class Highlight-Class' style={{ width: "150px" }}>{data[field]}</span></Tooltip>
          //   </Col>
          // </Row>
          <span>{data?.name}</span>
        );
      }
    },
    {
      label: "Actions",
      field: "Actions",
      render: (data, field) => {
        return (
          <div className="Hover-Buttons">
                      <Tooltip title="View in Workdrive">
                        <Button
                          className=""
                          type="default"
                          icon={<img style={{ width: "auto", height: "24px", cursor: 'pointer' }} src={icon} />}
                          style={{ width: "max-content", padding: "0px 5px" }}
                          onClick={(e) => {
                            window.open(data.permalink);
                          }}
                        >
                          View
                        </Button>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <Button
                          className=""
                          // color="red"
                          type="default"
                          icon={<DeleteOutlined />}
                          style={{ backgroundColor: "red", color: "white", width: "max-content", padding: "0px 5px" }}
                          onClick={(e) => removeAttachment(data)}
                        >
                          {/* Remove */}
                        </Button>
                      </Tooltip>
                    </div>
        );
      }
    },
]
  return (
    // <div>
    <div
      // isOpen={props.attachmentModal}
      // backdrop={"static"}
      // size="lg"
      className="taskdetail-modal-subtask Attachment-Section"
    // modalClassName="Create-Task-Attachment-Modal"
    // wrapClassName="Create-Task-Attachment-Modal-Wrap"
    // zIndex={9999}
    >
      {/* <ModalBody> */}
      <WorkdriveFolderPicker
        setUploading={setUploading}
        uploading={uploading}
        open={workdriveUploadModal} onChange={data => {
          
          handleUploadFromWorkdrive(data);
        }} setOpen={setWorkdriveUploadModal} />

      <CustomeCollapse rootClassName={"mt-2"} items={[{
        key: 0,
        label: <Badge color="#1677ff" style={{ right: "-13px", top: "50%" }} count={AllAttachments && AllAttachments.length > 0 ? AllAttachments.length : 0}>ATTACHMENTS</Badge>,
        children: (<>
          {AllAttachments.length > 0 && <div className="list-compact-view">
              <div onClick={(e) => { setActiveView("List") }} className="list-view" style={activeView == "List" ? { background: "#018EE0", color: "#fff" } : { background: "#fff" }}>List View</div>
              <div onClick={(e) => { setActiveView("Grid") }} className="compact-view" style={activeView == "Grid" ? { background: "#018EE0", color: "#fff" } : { background: "#fff" }}>Grid View</div>
            </div>}
          {activeView == "Grid" && <div className="Attachment-Card-Wrapper"> 
            {AllAttachments && AllAttachments.map(att => {
              return <Card
                hoverable
                className="Attachment-Prev-Card"
                style={{ width: 150 }}
                // actions={[
                //   <Tooltip title="View in Workdrive">
                //     <Button
                //       className=""
                //       type="default"
                //       icon={<img style={{ width: "auto", height: "24px", cursor: 'pointer' }} src={icon} />}
                //       style={{ width: "max-content", padding: "0px 5px" }}
                //       onClick={(e) => {
                //         window.open(att.permalink);
                //       }}
                //     >
                //       View
                //     </Button>
                //   </Tooltip>,
                //   <Tooltip title="Delete">
                //     <Button
                //       className=""
                //       // color="red"
                //       type="default"
                //       icon={<DeleteOutlined />}
                //       style={{ backgroundColor: "red", color: "white", width: "max-content", padding: "0px 5px" }}
                //       onClick={(e) => removeAttachment(att)}
                //     >
                //       {/* Remove */}
                //     </Button>
                //   </Tooltip>,
                // ]}
                cover={<div className="Hover-Card">
                  <img style={{
                    "width": "100%", "min-height": "11rem",
                  }} src={att.thumbnailUrl} />
                  <div className="Hover-Content">
                    <div className="Hover-Buttons">
                      <Tooltip title="View in Workdrive">
                        <Button
                          className=""
                          type="default"
                          icon={<img style={{ width: "auto", height: "24px", cursor: 'pointer' }} src={icon} />}
                          style={{ width: "max-content", padding: "0px 5px" }}
                          onClick={(e) => {
                            window.open(att.permalink);
                          }}
                        >
                          View
                        </Button>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <Button
                          className=""
                          // color="red"
                          type="default"
                          icon={<DeleteOutlined />}
                          style={{ backgroundColor: "red", color: "white", width: "max-content", padding: "0px 5px" }}
                          onClick={(e) => removeAttachment(att)}
                        >
                          {/* Remove */}
                        </Button>
                      </Tooltip>
                    </div>
                  </div>
                </div>}
              >
                <Meta title={att.name} />
              </Card>
            })}
          </div>}
          {activeView == "List" && AllAttachments.length > 0 && 
          <div className="Attachment-Card-Wrapper1"> 
            <CustomeTableComponent
                enableInlineAdd={false}
                Headers={DependanciesHeaders}
                firstHeaderLabel=""
                data={AllAttachments}
              ></CustomeTableComponent>
          </div>}
          </>),
      }]} />
      <div className="Attachment-Btn-Wrapper" sm={12}>
        <div className="Attachment-Btn-Wrapper-Right">
          {/* <Button
            icon={<HomeFilled />}
            // type="primary"
            style={{color:"#5a6c97", width: "max-content", padding: "0px 5px" }}
            className=""
            // onClick={(e) => props.handleUploadFiles(e)}
          >
            Computer
          </Button> */}
        </div>
        <div className="Attachment-Btn-Wrapper-Right">
          {uploadStack?.length > 0 ? (
            <Button
              icon={<PlusOutlined />}
              type="primary"
              style={{ width: "max-content", padding: "0px 5px" }}
              className=""
              onClick={(e) => handleUploadFiles(e)}
            >
              Add More Files
            </Button>
          ) : (
            ""
          )}
          {uploadStack?.length > 0 ? (
            <Button
              className=""
              type="primary"
              icon={<CloudUploadOutlined />}
              style={{ width: "max-content", padding: "0px 5px" }}
              onClick={(e) => uploadFiles(uploadStack)}
            >
              Upload All
            </Button>
          ) : (
            ""
          )}
          <Button
            className="mr-2"
            // type="primary"
            icon={<>
              <img style={{ width: "auto", height: "34px", cursor: 'pointer' }} src={icon} />
            </>}
            style={{ width: "max-content", padding: "0px 5px" }}
            onClick={(e) => {
              setWorkdriveUploadModal(true);
            }}
          >
            Upload From Workdrive
          </Button>
        </div>
        
      </div>
     
      {/* <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="job-parent-tabs ml-0"
          >
            <Tab eventKey="desktop" title="Desktop"> */}
      <div className="drop-file-box my-3 d-flex justify-content-center align-items-center "
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <ul
          className="d-flex flex-wrap p-0 "
          style={{ overflowY: "auto", maxHeight: "375px", padding: "14px !important", gap: "10px" }}
        >
          {uploadStack?.map((one) => {
            let ext = one.fileName.split(".");
            let extLength = ext.length - 1;
            console.log(ext);
            return (
              // <>
              //   <div className="card mx-1 mt-2" style={{ width: "14rem" }}>
              //     <div className="card-body">
              //       <h5>
              //         {getIcon(ext[extLength], one)}
              //         <p
              //           onClick={() =>
              //             handleAttachementRemove(one)
              //           }
              //           className="cursor-pointer float-right"
              //         >
              //           <FontAwesomeIcon
              //             className="task-attachment-modal-remove-icon"
              //             icon={faTimes}
              //           />
              //         </p>
              //       </h5>
              //       <h6 className="card-title">{one.fileName}</h6>
              //     </div>
              //     <div className="card-footer">
              //       {
              //         //    one.Status=="Success" ? <a
              //         //         className="card-link"
              //         //         // onClick={()=>props.uploadFiles(one)}
              //         //     >Delete
              //         //     </a> :
              //         <a
              //           className="card-link float-right"
              //           onClick={() => uploadFiles([one])}
              //         >
              //           Upload
              //         </a>
              //       }
              //     </div>
              //   </div>
              // </>
              <>
                <Card
                  hoverable
                  className="Attachment-Prev-Card"
                  style={{ width: 150 }}
                  cover={<div className="Hover-Card">
                    <img style={{
                      "width": "100%", "min-height": "11rem",
                    }} src={one.base64} />
                    <div className="Hover-Content">
                      <div className="Hover-Buttons">
                        <Tooltip title="View in Workdrive">
                          <Button
                            className=""
                            type="default"
                            icon={<FontAwesomeIcon color="#5b6c97" icon={faUpload} />}
                            style={{ width: "max-content", padding: "0px 5px" }}
                            onClick={(e) => {
                               uploadFiles([one]);
                            }}
                          >
                            Upload
                          </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <Button
                            className=""
                            // color="red"
                            type="default"
                            icon={<DeleteOutlined />}
                            style={{ backgroundColor: "red", color: "white", width: "max-content", padding: "0px 5px" }}
                            onClick={(e) => handleAttachementRemove(one)}
                          >
                            {/* Remove */}
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>}
                >
                  <Meta title={one.fileName} />
                </Card>
              </>
            );
          })}
        </ul>
        {props.fileNames.length > 0 ? (
          ""
        ) : (
          <Button onClick={(e) => handleUploadFiles(e)}>
            Click here to upload
          </Button>
        )}
      </div>
      {/* </Tab> */}
      {/* <Tab eventKey="workdrive" title="Workdrive">
              <Workdrive data={props.data} module={props.module} setRelativePathId={props.setRelativePathId}/>
            </Tab> */}
      {/* </Tabs> */}

      {/* <button
            onClick={() => {
              props.setAttachmentModal(false);
              props.setFileNames([]);
            }}
            className="btn bt-sm float-right btn-secondary"
          >
            Cancel
          </button> */}
      {/* </ModalBody> */}
    </div>
    // </div>
  );
};

export default AttachmentModal;
